
export default [
  // 信息列表
    {
        url: '/pat/getstudylist',
        type: 'post',
        response: params => {
          const { pageno,pagesize} = params.body
          return {
            "code": 1,
            "info": "ok",
            "pageno": parseInt(pageno),
            "pagesize": parseInt(pageno),
            "totalcount":  10,
            "list": [
              {
                "age": "73",
                "applydatetime": "2020-04-29 22:47:40",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "57279",
                "patientidentity": "4428464744042496000",
                "patientname": "cao yin shen M/68",
                "reportdocname": "Davi",
                "reportidentity": "6295665673578119168",
                "score": "100",
                "states": "未报告",
                "studydate": "2015-01-09 16:15:32",
                "studyid": "1",
                "studyidentity": "1747794797210271744",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588149830.698143",
                "studyparts": "颈部",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 05:00:40"
              },
              {
                "age": "65",
                "applydatetime": "2020-04-29 22:33:54",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "54724",
                "patientidentity": "7029321967140438016",
                "patientname": "jiao tian cheng M/60",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未审核",
                "studydate": "2014-10-29 10:04:28",
                "studyid": "1",
                "studyidentity": "1715370628955078656",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588149780.693356",
                "studyparts": "颈部",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:10:40"
              },
              {
                "age": "38",
                "applydatetime": "2020-04-29 20:21:05",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "MR31256",
                "patientidentity": "1756058984847933440",
                "patientname": "li yu liang M/36",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "待发布",
                "studydate": "2018-03-09 14:51:06",
                "studyid": "1",
                "studyidentity": "1756073603222110208",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588108881.629513",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:15:40"
              },
              {
                "age": "64",
                "applydatetime": "2020-04-29 17:54:34",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "MR19634",
                "patientidentity": "1776334941873668096",
                "patientname": "song yu liang M/61",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "已审核",
                "studydate": "2017-05-16 10:54:59",
                "studyid": "1",
                "studyidentity": "1776352949643935744",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588108218.573683",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:20:45"
              },
              {
                "age": "66",
                "applydatetime": "2020-04-26 15:18:50",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "53688",
                "patientidentity": "670194943322390528",
                "patientname": "wang xue mei F/61",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未报告",
                "studydate": "2014-10-01 11:09:58",
                "studyid": "1",
                "studyidentity": "670200258877095936",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1587885200.420357",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:25:45"
              },
              {
                "age": "87",
                "applydatetime": "2020-04-26 15:18:27",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "53685",
                "patientidentity": "575998342945734656",
                "patientname": "you gen ding M/82",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未报告",
                "studydate": "2014-10-01 10:26:42",
                "studyid": "1",
                "studyidentity": "576003440073670656",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1587885200.420291",
                "studyparts": "",
                "studystate": "普通",
                "timeout":"16",
                "checktimeout":"8",
                "uploaddocname": "",
                "uploadtime": "2020-06-16 11:30:15"
              }
            ],
            "main": null,
            "command": "",
            "data": null
          }
        }
      },
      // 报告详情
      {
        url: '/pat/queryreport',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": [
            {
              "address": "dfdgdfdfdf",
              "age": "43",
              "ai": null,
              "applyformurl": "",
              "canedit": "1",
              "checkdocname": "苑",
              "checkdocname1": "苑",
              "checktime": "2022-08-24 07:59:40",
              "diagnosishistory": "",
              "editreport": "1",
              "examresult": "1",
              "hasproperty": 1,
              "hospitalid": "2803480179421118464",
              "hospitalname": "测试医院-2组",
              "hospitalnick": "",
              "imagesaw": "1",
              "img": null,
              "logo": "/img/files/2851048947894550528.png",
              "medicalhistory": "",
              "modality": "MR",
              "name": "医匠第二影像中心",
              "needcloud": "1",
              "patientid": "MR2217048",
              "patientname": "ZUO GUO ZHANG",
              "printcount": "0",
              "qrcode": "",
              "reportdocname": "苑",
              "reportdocname1": "苑",
              "reportidentity": "7349262264270159872",
              "reportkey": "",
              "reportresult": "",
              "reportstatus": "-1",
              "reporttime": "2022-08-24 07:58:03",
              "reportvalue": "",
              "sex": "男",
              "sex1": "M",
              "shortname": "医匠影像中心-新郑",
              "showqrcode": "1",
              "showreporttime": "",
              "showresult": "0",
              "showshort": "0",
              "signurl": "/img/files/3302355666462670848.png",
              "signurl1": "/img/files/3302355666462670848.png",
              "signurl2": "/img/files/3302355666462670848.png",
              "states": "已审核",
              "studydate": "2022-06-04 00:00:00",
              "studyidentity": "608757025668497408",
              "studyinstanceuid": "1.2.392.200036.9125.2.138612190166.20220604000919",
              "studypart": "",
              "studyparts": "",
              "uploaddocname": "苑",
              "uploadtime": "2022-08-18 15:58:44",
              "writesignurl": "/img/files/3302355666462670848.png"
            }
          ],
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/rep/recordlist',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": [
            {
              "createtime": "2022-08-24 07:59:40",
              "opername": "苑",
              "params": "{\"checkdocid\":\"3609256342121971712\",\"hospitalid\":\"2803480179421118464\",\"lcanedit\":1,\"ldoctorid\":\"4481862665991258112\",\"ldoctype\":\"2\",\"lhospitalcode\":\"\",\"lhospitalid\":\"0\",\"loperator\":\"web\",\"lpartnershipid\":\"6126874654968741888\",\"lrightlist\":\"20600001,20100001,20200001,20200002,20200003,24000002,20400001,2019000001,2019000002,2019000003,20210001,\",\"lroleid\":\"14\",\"lsettemplate\":\"0\",\"luserid\":\"3609256342121971712\",\"lusername\":\"苑\",\"reportidentity\":\"7349262264270159872\",\"reportstatus\":2,\"score\":\"100\",\"scoreidentity\":\"6787233291268161536\",\"signurl\":\"/img/files/3302355666462670848.png\",\"studyidentity\":\"608757025668497408\",\"studyinstanceuid\":\"1.2.392.200036.9125.2.138612190166.20220604000919\",\"studypartmd5\":\"d41d8cd98f00b204e9800998ecf8427e\"}",
              "remark": "审核了报告"
            },
            {
              "createtime": "2022-08-24 07:58:03",
              "opername": "苑",
              "params": "{\"checkdocid\":\"3609256342121971712\",\"hospitalid\":\"2803480179421118464\",\"lcanedit\":1,\"ldoctorid\":\"4481862665991258112\",\"ldoctype\":\"2\",\"lhospitalcode\":\"\",\"lhospitalid\":\"0\",\"loperator\":\"web\",\"lpartnershipid\":\"6126874654968741888\",\"lrightlist\":\"20600001,20100001,20200001,20200002,20200003,24000002,20400001,2019000001,2019000002,2019000003,20210001,\",\"lroleid\":\"14\",\"lsettemplate\":\"0\",\"luserid\":\"3609256342121971712\",\"lusername\":\"苑\",\"reportidentity\":\"7349262264270159872\",\"reportstatus\":1,\"studyidentity\":\"608757025668497408\",\"studyinstanceuid\":\"1.2.392.200036.9125.2.138612190166.20220604000919\",\"studypartmd5\":\"d41d8cd98f00b204e9800998ecf8427e\",\"writesignurl\":\"/img/files/3302355666462670848.png\"}",
              "remark": "发布了报告"
            },
            {
              "createtime": "2022-08-23 09:04:05",
              "opername": "苑",
              "params": "{\"examresult\":\"1\",\"hospitalid\":\"2803480179421118464\",\"imagesaw\":\"1\",\"isadd\":1,\"lastoperator\":\"web\",\"lcanedit\":1,\"ldoctorid\":\"4481862665991258112\",\"ldoctype\":\"2\",\"lhospitalcode\":\"\",\"lhospitalid\":\"0\",\"loperator\":\"web\",\"lpartnershipid\":\"6126874654968741888\",\"lrightlist\":\"20600001,20100001,20200001,20200002,20200003,24000002,20400001,2019000001,2019000002,2019000003,20210001,\",\"lroleid\":\"14\",\"lsettemplate\":\"0\",\"luserid\":\"3609256342121971712\",\"lusername\":\"苑\",\"patientidentity\":\"608724556940476416\",\"reportdocid\":\"3609256342121971712\",\"reportdocname\":\"苑\",\"reportidentity\":\"7349262264270159872\",\"studyidentity\":\"608757025668497408\",\"studypart\":\"\",\"studypartmd5\":\"d41d8cd98f00b204e9800998ecf8427e\"}",
              "remark": "新增了报告"
            }
          ],
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/rep/getsimilarpat',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": null,
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/pat/getreporttree1',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": [
            {
              "children": [
                {
                  "children": null,
                  "emrtemplateidentity": "100",
                  "id": "73472",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "五官",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "101",
                  "id": "73582",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "颈部",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "102",
                  "id": "73688",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "腹部",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "103",
                  "id": "73799",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "盆腔",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "104",
                  "id": "73910",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "脊柱",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "105",
                  "id": "74020",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "四肢",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "106",
                  "id": "74131",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "胸部",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "107",
                  "id": "74242",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "纵隔",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "108",
                  "id": "74353",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "头颅",
                  "lev": "2",
                  "parentidentity": "1",
                  "userid": ""
                }
              ],
              "emrtemplateidentity": "1",
              "id": "73471",
              "isdir": "1",
              "isprivete": "0",
              "label": "CT",
              "lev": "1",
              "parentidentity": "0"
            },
            {
              "children": [
                {
                  "children": null,
                  "emrtemplateidentity": "110",
                  "id": "74383",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "颈部",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "111",
                  "id": "74401",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "五官",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "112",
                  "id": "74440",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "胸部",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "113",
                  "id": "74477",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "盆腔",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "114",
                  "id": "74479",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "脊柱",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "115",
                  "id": "74480",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "四肢",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "116",
                  "id": "74481",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "腹部",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "3841110095003648",
                  "id": "77566",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "颅脑正常",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "375764508271869952",
                  "id": "77567",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "脑白质脱髓鞘",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "759438129290444800",
                  "id": "77568",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "脱髓鞘+脑萎缩",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "1475362203803484160",
                  "id": "77569",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "梗、脱、萎缩",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "2139249960225243136",
                  "id": "77570",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "颈椎间盘突出",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "2884012189788569600",
                  "id": "77571",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "腰椎间盘突出",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                },
                {
                  "children": null,
                  "emrtemplateidentity": "3465882432182321152",
                  "id": "77572",
                  "isdir": "0",
                  "isprivete": "0",
                  "label": "膝关节半月板变性",
                  "lev": "2",
                  "parentidentity": "2",
                  "userid": "1005857671624097792"
                }
              ],
              "emrtemplateidentity": "2",
              "id": "74570",
              "isdir": "1",
              "isprivete": "0",
              "label": "MR",
              "lev": "1",
              "parentidentity": "0"
            },
            {
              "children": [
                {
                  "children": null,
                  "emrtemplateidentity": "117",
                  "id": "74482",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "妇产",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "118",
                  "id": "74483",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "四肢",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "119",
                  "id": "74511",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "呼吸",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "120",
                  "id": "74544",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "泌尿",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "121",
                  "id": "74555",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "头颅",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "122",
                  "id": "74556",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "消化",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "123",
                  "id": "74557",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "循环",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "124",
                  "id": "74558",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "脊柱",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "131",
                  "id": "74559",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "五官",
                  "lev": "2",
                  "parentidentity": "3",
                  "userid": ""
                }
              ],
              "emrtemplateidentity": "3",
              "id": "74580",
              "isdir": "1",
              "isprivete": "0",
              "label": "CR/DR/普放",
              "lev": "1",
              "parentidentity": "0"
            },
            {
              "children": [
                {
                  "children": null,
                  "emrtemplateidentity": "132",
                  "id": "74560",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "分类",
                  "lev": "2",
                  "parentidentity": "4",
                  "userid": ""
                }
              ],
              "emrtemplateidentity": "4",
              "id": "74609",
              "isdir": "1",
              "isprivete": "0",
              "label": "DSA",
              "lev": "1",
              "parentidentity": "0"
            },
            {
              "children": [
                {
                  "children": null,
                  "emrtemplateidentity": "6",
                  "id": "74926",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "胸腹部",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "7",
                  "id": "74927",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "颅脑",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "8",
                  "id": "74928",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "面颈部",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "9",
                  "id": "74930",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "胃肠",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "3362",
                  "id": "74596",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "肝胆胰脾双肾",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "3849",
                  "id": "74604",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "泌尿系统",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5070",
                  "id": "74730",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "浅表器官",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5216",
                  "id": "74779",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "浅表淋巴结",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5220",
                  "id": "74781",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "腹腔淋巴结",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5227",
                  "id": "74784",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "外周血管",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5258",
                  "id": "74795",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "腹部血管",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5262",
                  "id": "74797",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "男性生殖系",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5299",
                  "id": "74810",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "骨关节软组织",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5309",
                  "id": "74814",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "介入",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5328",
                  "id": "74821",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "造影",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5500",
                  "id": "74879",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "产科",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5501",
                  "id": "74880",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "妇科",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                },
                {
                  "children": null,
                  "emrtemplateidentity": "5502",
                  "id": "74881",
                  "isdir": "1",
                  "isprivete": "0",
                  "label": "附件",
                  "lev": "2",
                  "parentidentity": "5",
                  "userid": ""
                }
              ],
              "emrtemplateidentity": "5",
              "id": "74704",
              "isdir": "1",
              "isprivete": "0",
              "label": "US",
              "lev": "1",
              "parentidentity": "0"
            }
          ],
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/pat/querystudypart',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": [
            {
              "studyparts": ""
            }
          ],
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/rep/dispacthdoc',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "ok",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": null,
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/rep/editreportveriy',
        type: 'post',
        response: _ => {
         return  {
          "code": 0,
          "info": "报告异常",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": null,
          "main": null,
          "command": "",
          "data": null
        }
       }
      },
      {
        url: '/rep/editreportveriy',
        type: 'post',
        response: _ => {
         return  {
          "code": 1,
          "info": "报告异常",
          "pageno": 0,
          "pagesize": 0,
          "totalcount": 0,
          "list": null,
          "main": null,
          "command": "",
          "data": null
        }
       }
    },
    {
      url: '/rep/reporttimestatmp',
      type: 'post',
      response: _ => {
       return  {
        "code": 0,
        "info": "报告异常",
        "pageno": 0,
        "pagesize": 0,
        "totalcount": 0,
        "list": null,
        "main": null,
        "command": "",
        "data": null
      }
     }
    },
    {
      url: '/pat/publishreport',
      type: 'post',
      response: _ => {
      return  {
        "code": 0,
        "info": "报告异常",
        "pageno": 0,
        "pagesize": 0,
        "totalcount": 0,
        "list": null,
        "main": null,
        "command": "",
        "data": null
      }
    }
  },
  {
    url: '/pat/checkreport',
    type: 'post',
    response: _ => {
    return  {
      "code": 0,
      "info": "报告异常",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": null,
      "main": null,
      "command": "",
      "data": null
    }
  }
  },
  {
    url: '/pat/editreport',
    type: 'post',
    response: _ => {
    return  {
      "code": 0,
      "info": "报告异常",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": null,
      "main": null,
      "command": "",
      "data": null
    }
  }
  },
  {
    url: '/pat/newreport',
    type: 'post',
    response: _ => {
    return  {
      "code": 0,
      "info": "报告异常",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": null,
      "main": null,
      "command": "",
      "data": null
    }
  }
  },
]